module.exports = __webpack_public_path__ + "static/media/shipping-calculator-icon.eb3a614c.svg";